var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"DataOutputFireEditor"},[_c('EditorSelect',_vm._b({attrs:{"multiple":"","_key":_vm.key,"options":_vm.outputOptions}},'EditorSelect',{ label: _vm.label },false))],1)}
var staticRenderFns = []

export { render, staticRenderFns }